import { render, staticRenderFns } from "./about.vue?vue&type=template&id=ebf02894&scoped=true"
import script from "./about.vue?vue&type=script&lang=js"
export * from "./about.vue?vue&type=script&lang=js"
import style0 from "./about.vue?vue&type=style&index=0&id=ebf02894&prod&scoped=true&lang=css"
import style1 from "./about.vue?vue&type=style&index=1&id=ebf02894&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ebf02894",
  null
  
)

export default component.exports